import { AxiosResponse, AxiosInstance } from 'axios';
import AttributeModel, {
  AttributeFilterParams,
  AttributePriceParams,
} from '@/models/AttributeModel';
import ConfigurationModel from '../models/ConfigurationModel';
import IncompleteOrderModel from '@/models/IncompleteOrderModel';

export default class ConfigurationService {
  private axiosInstance: AxiosInstance;

  public constructor(axiosInstance: AxiosInstance) {
    this.axiosInstance = axiosInstance;
  }
  // tslint:disable-next-line: max-line-length
  public async GetFilteredAttributes(
    attributeType: number,
    attributeFilterParams: AttributeFilterParams[],
  ): Promise<AttributeModel[]> {
    const url: string = `Configuration/attributes/${attributeType}`;
    // tslint:disable-next-line: max-line-length
    const res: AxiosResponse<AttributeModel[]> = await this.axiosInstance.post<
      AttributeModel[]
    >(url, attributeFilterParams);
    return res.data;
  }

  public async GetFilteredConfigurations(
    attributeFilterParams: AttributePriceParams[],
  ): Promise<ConfigurationModel> {
    const url: string = `Configuration/filtered`;
    // tslint:disable-next-line: max-line-length
    const res: AxiosResponse<
      ConfigurationModel
    > = await this.axiosInstance.post<ConfigurationModel>(
      url,
      attributeFilterParams,
    );
    return res.data;
  }

  public async GetAttributes(
    selectedAttributeId: number,
    attributeType: number,
  ): Promise<AttributeModel[]> {
    const url: string = `Configuration/${selectedAttributeId}/attributes/${attributeType}`;
    const res: AxiosResponse<AttributeModel[]> = await this.axiosInstance.get<
      AttributeModel[]
    >(url);
    return res.data;
  }

  public async GetProduct(
    data: Record<string, string | number | number[]>,
  ): Promise<ConfigurationModel | null> {
    const url: string = `Product/search`;
    const res: AxiosResponse<ConfigurationModel | null> = await this.axiosInstance.post<ConfigurationModel | null>(
      url,
      data,
    );
    return res.data;
  }

  public async GetPatternByParam(params: {
    manufacturerId: number;
    modelGroupId: number;
    modelId: number;
    generation: string;
    seatCount: number;
    transmissionId: number;
  }): Promise<boolean> {
    const url: string = `Pattern/findByParam`;
    const res: AxiosResponse<object[] | null> = await this.axiosInstance.get<
      object[]
    >(url, {
      params,
    });
    return res.data && res.data.length > 0 ? true : false;
  }
}
